import React, { Component } from 'react'
import errorService from '../../utils/analytics/error'

const withErrorBoundary = BaseComponent => {
  class WithErrorBoundaryWrapper extends Component {
    constructor(props) {
      super(props)

      this.state = {
        hasError: false,
      }

      this.reportError = error => {
        errorService.report(error)
      }
    }

    componentDidCatch(error, info) {
      console.log(error)
      console.log(info)
      this.reportError(error)
      // error is the error that was thrown
      // info is the stack trace
      this.setState({ hasError: true })
    }

    render() {
      const { hasError } = this.state

      if (hasError) return null

      return <BaseComponent {...this.props} />
    }
  }

  return WithErrorBoundaryWrapper
}

export default withErrorBoundary



// WEBPACK FOOTER //
// ./src/components/hocs/withErrorBoundaryReturnNull.js